import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Alert } from '@material-ui/lab';

import Container from './Container';
import {IFeedbackRequest,IFeedbackResponse} from '../types';
import api from '../lib/baseAxios';

const ContactUs = () => {

  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [feedback, setFeedback] = useState('');
  const [isEmailError, setIsEmailError] = useState(false);
  const [isNameError, setIsNameError] = useState(false);
  const [isFeedbackError, setIsFeedbackError] = useState(false);
  const [feedbackResponse,setFeedbackResponse]=useState<IFeedbackResponse>();
  const [isLoading, setIsLoading]=useState(false);

  const validateEmail=(input:any)=>{
    const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const result = reg.test(input);
    const b1 = input === '';
    const error = !result && !b1;
    setIsEmailError(error);
  }

  const handleEmailChange = (event: { target: { value: any; }; }) => {
    setEmail( event.target.value );
    validateEmail(event.target.value);
  };

  const handleNameChange = (event: { target: { value: any; }; }) => {
    setName( event.target.value );
    const error=event.target.value === '' ;
    setIsNameError(error)
  };

  const handleFeedbackChange = (event: { target: { value: any; }; }) => {
    setFeedback( event.target.value );
    const error=event.target.value === '' ;
    setIsFeedbackError(error);
  };

  const resetTextFields=()=>{
    setEmail('');
    setName('');
    setFeedback('');
    setIsEmailError(false);
    setIsNameError(false);
    setIsFeedbackError(false);
  }

  const handleClick = async (e) => {

    !name && setIsNameError(true);
    !email && setIsEmailError(true);
    !feedback && setIsFeedbackError(true);

    if (!name || !email || !feedback) return null;

    setIsLoading(true);
    const data: IFeedbackRequest = { name, email, feedback };
    await api.post("/v1/feedback", data)
      .then(result => {
        setFeedbackResponse(result.data);
        resetTextFields();
        setIsLoading(false);
      })
      .catch(err => {
        setFeedbackResponse({
          data: {},
          message: "Something went wrong. Please try again in few minutes.",
          success: false,
        });
        setIsLoading(false);
      })
    return null;
  };


  const ResponseMessage = () => {
  
    if (feedbackResponse) {
      if (feedbackResponse.success) {
        return (
          <div>
            <Alert severity="success" className="response-text">{feedbackResponse.message}</Alert>
          </div>
        );
      }
     else if (!feedbackResponse.success) {
        return (
          <div>
            <Alert severity="error" className="response-text">{feedbackResponse.message}</Alert>
          </div>
        );
      }
    }
    return null;
  };

  return (
    <div className="contact-us" id="contact">
      <Container>
        <h2 className="global-heading large-font">Contact Us</h2>
        <h3 className="description small-font">
          Need help? Write to us and our support team will answer all your
          queries.
        </h3>
        <Grid container className="grid-container" spacing={3}>
          <Grid item md={6} xs={12} className="text-left">
            <TextField
              fullWidth
              id="outlined-basic"
              label="Name"
              variant="outlined"
              value={name}
              onChange={(e)=>handleNameChange(e)}
              helperText={isNameError ? 'Name field cannot be empty. Please enter your name.' : ""}

            />
          </Grid>
          <Grid item md={6} xs={12} className="text-right">
            <TextField
              fullWidth
              id="outlined-basic"
              label="Email"
              variant="outlined"
              value={email}
              onChange={(e)=>handleEmailChange(e)}
              helperText={
                isEmailError
                  ? 'Invalid Email address. Please enter a correct email.': ""
              }
            />
          </Grid>
          <Grid item xs={12} className="text-bottom">
            <TextField
              multiline
              rows={4}
              fullWidth
              id="outlined-basic"
              label="Your Message"
              variant="outlined"
              value={feedback}  
              onChange={(e)=>handleFeedbackChange(e)}
            />
          </Grid>
        </Grid>
        <Button
          className="left-button red-button medium-font"
          variant="contained"
          onClick={(e)=>handleClick(e)} disabled={isLoading}
        >
          Send Message
        </Button>

        <div className="response-alert">
          {ResponseMessage()}
        </div>
      </Container>
    </div>
  );
};

ContactUs.propTypes = {
  sectionData: PropTypes.any.isRequired,
};

export default ContactUs;
